import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { updateMyAdminProfile } from '@/api/admins';
import { QueryKeys } from '@gokrew/models/constants';

export function useUpdateAdminLanguage() {
  const queryClient = useQueryClient();
  const { t } = useTranslation('common');

  return useMutation({
    mutationFn: (language: string) =>
      updateMyAdminProfile({ user: { language } }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.Profile] });
    },
    onError: () => {
      toast.error(t('top_nav.language_update_failed'));
    },
  });
}
